<div id="pdf-generate" class="col-md-12 col-lg-12 col-sm-12 col-padding">   
    <div *ngIf="formData">
         <div class="heading-title col-md-8 col-lg-8 col-sm-8 col-padding">
             <h1>340B Entity Verification Form</h1>
         </div>
         <div class="heading-logo col-md-4 col-lg-4 col-sm-4 col-padding">
             <img 
                 style="float: right;"                              
                 role="button"
                 alt="Cardinal Logo"
                 src="../../../../assets/images/cardinalLogo.svg"
             />
         </div>
         <div class="col-md-12 col-lg-12 col-sm-12 parga-1 col-padding">
             <p>Dear Provider</p> 
             <p> To required access to the 340B Drug Discount Pricing Program please complete all the information
                 requested below and submit for the eligiblity verification.
             </p> 
         </div>
       
         <div class="col-md-12 col-lg-12 col-sm-12 parga-2 col-padding">
             <p>Please provide the following information</p>            
         </div>
         <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
             <p> Customer Name (Hospital Name)</p>
             <p> (as listed on HRSA site)</p>
             <p>{{ formData.customerName }}</p>
         </div>
         <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
            <p> 340B ID Number</p>
            <p> (as listed on HRSA site)</p>
            <p>{{ formData.id }}</p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field2-col-para col-padding">
            <p> Hospital 340B Administrator Name</p>           
            <p>{{ formData.hospital340BAdministratorName }} </p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field2-col-para col-padding">
            <p> Hospital 340B Administrator Email Address</p>           
            <p>{{ formData.hospital340BAdministratorEmail }} </p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
            <p class="pdf-col-label"> Product "Ship to" Address</p>
            <p> (Street,City,State,Zip)</p>
            <p class="prod-address">{{ formData.prodShiptoAddress }},{{ formData.prodShiptoCity }}
                {{ formData.prodShiptoState }},{{ formData.prodShiptoZip }}
            </p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
           <p class="pdf-col-label"> Product "Bill to" Address</p>
           <p> (Street,City,State,Zip)</p>
           <p class="prod-address">{{ formData.productBillToAddress }},{{ formData.city }}
            {{ formData.state }},{{ formData.zip }}
        </p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
            <p class="pdf-col-label"> Cardinal Health Customer "Ship to" 10 digit Number</p>
            <p> (starting with 2100)</p>
            <p> {{ formData.customerShipToNum }}</p>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-6 field-col-para col-padding">
            <p class="pdf-col-label"> Cardinal Health Customer "Bill to" 10 digit Number</p>
            <p> (starting with 3000)</p>
            <p>{{ formData.hospitalBillNumber }}</p>
        </div>
        <div class="col-md-12 col-lg-12 col-sm-12 field2-col-para col-padding">
            <p> Cardinal Health Nuclear Pharmacy</p>           
            <p>{{ formData.pharmacyName }} - {{ formData.locationNum }}</p>
        </div>

        <div class="col-md-12 col-lg-12 col-sm-12 footer-para-1 col-padding">           
            <p>The form submitter and the 340B Administrator will be notified of entity eligiblity
                status within two business days
            </p>
            <hr class="hr-line"> 
        </div>
       </div>   
 </div>